import { Box, Grid, Stack, Typography } from '@mui/material';
import VideoPlayerView from 'js/components/support/video/VideoPlayerView';
import { flowDataMap } from 'new/elements/flows/dataMap';
import React, { FC } from 'react';
import classes from './FlowInfo.module.scss';

export type FlowInfoProps = {
  flowType: string;
  flowTypeCTA: React.ReactNode | null;
  Image: React.ReactNode | null;
};

const FlowInfo: FC<FlowInfoProps> = ({ flowType, flowTypeCTA, Image }) => {
  const { title, description, videoUrl, ImageComponent } = flowDataMap[flowType];
  const displayImage = Image ?? ImageComponent;
  return (
    <Box className={classes.right}>
      <Box className={classes.right_top}>
        <Box className={classes.flowSelected}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={7}>
              <Typography variant="h3" component="div" className={classes.flowTitle}>
                {title}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              {flowTypeCTA}
            </Grid>
            <Grid item xs={3} justifyItems="center">
              <Box sx={{ mt: 1 }}>{displayImage}</Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className={classes.explanation}>
        <Box className={classes.videoThumb}>
          <VideoPlayerView videoId={flowType} videoUrl={videoUrl} />
        </Box>
        <div className={classes.description}>{description}</div>
      </Box>
    </Box>
  );
};

export default FlowInfo;
